import { BraintreeCardType, CardType } from '@order/graphql';

/**
 * The card type can be from any provider, so we map it here.
 */
export function getCreditCardIcon(
  cardType: CardType | BraintreeCardType | 'NEW' = CardType.Unsupported,
) {
  switch (cardType) {
    case CardType.Amex:
    case CardType.AmericanExpress:
    case BraintreeCardType.AmEx: {
      return 'IconCcAmex';
    }

    case CardType.Discover:
    case BraintreeCardType.Discover: {
      return 'IconCcDiscover';
    }

    case CardType.MasterCard:
    case BraintreeCardType.MasterCard: {
      return 'IconCcMasterCard';
    }

    case CardType.Visa:
    case BraintreeCardType.Visa: {
      return 'IconCcVisa';
    }

    default: {
      return 'IconCreditCard';
    }
  }
}
